import { useContext, useEffect, useState } from 'react';
import { ConversationsContext } from '../../../../context/ConversationsProvider';
import useViewer from '@hooks/useViewer';

const useAllParticipants = () => {
    const { conversations } = useContext(ConversationsContext);
    const { viewer } = useViewer();
    const [allParticipants, setAllParticipants] = useState();
    const [allParticipantIdentities, setAllParticipantIdentities] = useState();

    useEffect(() => {
        (async () => {
            if (!viewer) return;
            const promises = conversations.map(async convo => {
                const participants = await convo.getParticipants();
                const notCurrentMembers = participants.filter(p => p.state.identity !== viewer.id);
                return notCurrentMembers;
            });
            const otherParticipants = await Promise.all(promises);
            setAllParticipants(otherParticipants);
            setAllParticipantIdentities(otherParticipants.flat().map(p => p.state.identity));
        })();
    }, [conversations, viewer]);

    return { allParticipants, allParticipantIdentities };
};

export default useAllParticipants;
